/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-03 11:08:32
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-09 11:38:54
 * @FilePath: /zeelool-nextjs/src/components/Responsive/WapOnly.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { EPlatform } from '@/utils/enums/platform-enum';
import React, { useContext } from 'react';
import { ResponsiveContext } from './ResponsiveProvider';

interface WapOnlyProps {
  /** 插槽内容 */
  children: React.ReactNode;
  /** app 端是否不渲染 */
  hideApp?: boolean;
}
export default function WapOnly({ children, hideApp = false }: WapOnlyProps) {
  const { deviceType } = useContext(ResponsiveContext);

  let isShow = true;
  if ([EPlatform.WEB].includes(deviceType)) {
    isShow = false;
  }

  if (hideApp && [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType)) {
    isShow = false;
  }

  return isShow ? children : null;
}
